// extracted by mini-css-extract-plugin
export default {"accountPage":"DashboardHome_accountPage__g3qj7","title":"DashboardHome_title__RGz8D","accountHeader":"DashboardHome_accountHeader__o488q"};